import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

/* PRODUCT IMAGES */
import panel001 from "../assets/gallery/manufacturing/024.jpeg";
import panel002 from "../assets/gallery/manufacturing/028.jpg";
import panel003 from "../assets/gallery/manufacturing/058.jpg";
import panel004 from "../assets/gallery/manufacturing/059.jpeg";
import panel005 from "../assets/gallery/manufacturing/039.jpg";
import panel006 from "../assets/gallery/manufacturing/030.jpg";
import panel007 from "../assets/gallery/manufacturing/041.jpg";
import panel008 from "../assets/gallery/manufacturing/017.jpg";
import panel009 from "../assets/gallery/manufacturing/040.jpg";
import panel010 from "../assets/gallery/manufacturing/018.jpg";
import panel011 from "../assets/gallery/manufacturing/015.jpeg";
import panel012 from "../assets/gallery/manufacturing/054.jpeg";
import panel013 from "../assets/gallery/manufacturing/067.jpg";
import panel014 from "../assets/gallery/manufacturing/016.jpg";
import panel015 from "../assets/gallery/manufacturing/019.jpg";
import panel016 from "../assets/gallery/manufacturing/008.jpeg";
import panel017 from "../assets/gallery/manufacturing/064.jpeg";
import panel018 from "../assets/gallery/manufacturing/065.jpg";
import panel019 from "../assets/gallery/manufacturing/072.jpg";
import panel020 from "../assets/gallery/manufacturing/013.jpg";
import panel021 from "../assets/gallery/manufacturing/074.jpeg";

/* PRODUCT DATA */

const products = [
  { name:"Power Distribution Board (PDB Panel)",image:panel001,category:"Distribution",desc:"Panels for safe industrial power distribution."},
  { name:"Power Control Centre (PCC Panel)",image:panel002,category:"Distribution",desc:"Main electrical distribution and control panels."},
  { name:"Motor Control Centre (MCC Panel)",image:panel003,category:"Distribution",desc:"Centralized motor control with protection systems."},
  { name:"High Tension Panel (HT Panel)",image:panel004,category:"Power",desc:"High voltage panels for industrial electrical systems."},
  { name:"Low Tension Panel (LT Panel)",image:panel005,category:"Power",desc:"Low voltage power distribution panels."},
  { name:"Automatic Power Factor Control Panel",image:panel006,category:"Power",desc:"Maintains optimal power factor automatically."},
  { name:"Auto Main Failure Panel (AMF Panel)",image:panel007,category:"Automation",desc:"Automatic switching between mains and generator."},
  { name:"Sub Distribution Panels",image:panel008,category:"Distribution",desc:"Secondary power distribution panels."},
  { name:"AC Drive Panels",image:panel009,category:"Automation",desc:"Panels controlling motor speed using drives."},
  { name:"Feeder Pillar Panels",image:panel010,category:"Distribution",desc:"Outdoor electrical power distribution panels."},
  { name:"Fire Control Panels",image:panel011,category:"Safety",desc:"Integrated fire detection and electrical control panels."},
  { name:"PCC Extension Panels",image:panel012,category:"Distribution",desc:"Panels used for expanding PCC systems."},
  { name:"Air Circuit Breaker Panels (ACB)",image:panel013,category:"Power",desc:"High capacity electrical protection panels."},
  { name:"Programmable Logic Controller Panels",image:panel014,category:"Automation",desc:"Industrial automation panels using PLC."},
  { name:"Control Desks",image:panel015,category:"Automation",desc:"Operator control stations for automation systems."},
  { name:"Busbar Trunking Panels",image:panel016,category:"Power",desc:"Efficient high capacity power distribution systems."},
  { name:"Lighting Distribution Board (LDB)",image:panel017,category:"Distribution",desc:"Lighting circuit distribution panels."},
  { name:"Relay and Time Control Panels (RTCC)",image:panel018,category:"Automation",desc:"Monitoring and control using relay logic."},
  { name:"Automatic Voltage Stabilizers",image:panel019,category:"Power",desc:"Servo stabilizers for stable voltage supply."},
  { name:"Generator Synchronization Panels",image:panel020,category:"Power",desc:"Synchronizes multiple generators."},
  { name:"Variable Frequency Drives (VFD)",image:panel021,category:"Automation",desc:"Motor speed control and energy efficiency."}
];

const Products = () => {

const [selectedProduct,setSelectedProduct]=useState(null);
const [category,setCategory]=useState("All");

/* FILTER PRODUCTS */

const filteredProducts =
category==="All"
?products
:products.filter(p=>p.category===category);

/* PRODUCT DETAIL VIEW */

if(selectedProduct){
return(

<section style={{padding:"80px 0",background:"#fff"}}>

<Container>

<Button
variant="secondary"
style={{marginBottom:"30px"}}
onClick={()=>setSelectedProduct(null)}
>
← Back to Products
</Button>

<Row>

<Col md={6}>
<img
src={selectedProduct.image}
alt={selectedProduct.name}
style={{width:"100%",borderRadius:"10px"}}
/>
</Col>

<Col md={6}>

<h2 style={{color:"#E42525",fontWeight:"700",marginBottom:"20px"}}>
{selectedProduct.name}
</h2>

<p style={{fontSize:"1.05rem",lineHeight:"1.7",color:"#000"}}>
{selectedProduct.desc}
</p>

<Button
style={{marginTop:"20px",background:"#0054A6",border:"none"}}
onClick={()=>{

const message=`Hello Vigneshwara Power Controls,

I am interested in:

${selectedProduct.name}

Please share quotation and details.

Thank you.`;

window.open(
`https://wa.me/917396748509?text=${encodeURIComponent(message)}`,
"_blank"
);

}}
>
Request Quote
</Button>

</Col>

</Row>

</Container>

</section>

);
}

/* PRODUCT GRID */

return(

<section style={{padding:"80px 0",background:"#fff"}}>

<Container>

<div className="section-header">

  <div className="section-eyebrow">
    OUR PRODUCTS
  </div>

  <h2 className="section-title">
    Industrial Control Panels
  </h2>

  <p className="section-subtitle">
    High-quality electrical control panels designed for industrial performance and safety.
  </p>

</div>

{/* FILTER BUTTONS */}

<div style={{textAlign:"center",marginBottom:"40px"}}>

<Button
className={category==="All"?"btn-red":"btn-red-outline"}
style={{margin:"5px"}}
onClick={()=>setCategory("All")}
>
All
</Button>

<Button
className={category==="All"?"btn-red":"btn-red-outline"}
style={{margin:"5px"}}
onClick={()=>setCategory("Distribution")}
>
Distribution
</Button>

<Button
className={category==="All"?"btn-red":"btn-red-outline"}
style={{margin:"5px"}}
onClick={()=>setCategory("Power")}
>
Power
</Button>

<Button
className={category==="All"?"btn-red":"btn-red-outline"}
style={{margin:"5px"}}
onClick={()=>setCategory("Automation")}
>
Automation
</Button>

<Button
className={category==="All"?"btn-red":"btn-red-outline"}
style={{margin:"5px"}}
onClick={()=>setCategory("Safety")}
>
Safety
</Button>

</div>

<Row>

{filteredProducts.map((product,index)=>(

<Col md={4} key={index} style={{marginBottom:"30px"}}>

<Card
style={{cursor:"pointer",border:"1px solid #eee"}}
onClick={()=>setSelectedProduct(product)}
>

<Card.Img
variant="top"
src={product.image}
style={{height:"220px",objectFit:"cover"}}
/>

<Card.Body>

<Card.Title style={{fontSize:"1.1rem"}}>
{product.name}
</Card.Title>

<Card.Text style={{fontSize:"0.9rem",color:"#555"}}>
{product.desc.substring(0,90)}...
</Card.Text>

<Button className="btn-red-outline" size="sm">
View Details
</Button>

</Card.Body>

</Card>

</Col>

))}

</Row>

</Container>

</section>

);

};

export default Products;